export const useDefaultData = ({helpers}) => {

    const {getCurrentDate} = helpers

    const defaultFormGlobal = {
        idcredito: 0
    }
    const defaultDataModal = {
        open: false,
        titleModal: '',
        componentModal: '',
        dataRequest: {},
    }


    return Object.freeze({
        defaultDataModal,
        defaultFormGlobal
    })
}